import { NsKey } from "enums/NsKey";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";
import { FC, useCallback, useMemo } from "react";

interface PsyBuybackToggleProps {
  isPsyBuyback: boolean;
  onToggle: () => void;
}

const BASE_CLASS = "text-sm py-0 px-1.5 rounded-full transition-all duration-200 focus:outline-none";

export const PsyBuybackToggle: FC<PsyBuybackToggleProps> = ({
  isPsyBuyback,
  onToggle
}) => {
  const { t } = useDynamicTranslation([NsKey.Borrower]);

  const handleClick = useCallback(() => {
    onToggle();
  }, [onToggle]);

  const buttonClassName = useMemo(() => {
    if (isPsyBuyback) {
      return `${BASE_CLASS} text-primary border border-primary hover:opacity-70 cursor-pointer`;
    }
    return `${BASE_CLASS} text-gray-500 border border-gray-400 border-dashed hover:border-primary hover:text-primary cursor-pointer`;
  }, [isPsyBuyback]);

  return (
    <button
      type="button"
      onClick={handleClick}
      className={buttonClassName}
      title={t('BORROWER_LOAN_FORM.LABELS.PSY_BUYBACK')}
    >
      Dos Psy
    </button>
  );
};
